<!--
 * @Description: 体动动态
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2023-08-23 10:10:44
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2023-11-15 10:39:45
 -->
<template>
  <div class="sleepTimes">
    <div class="eacharts">
      <echarts
        :chart-id="'sleepTimes'"
        :chart-option="options"
      ></echarts>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    heartRateStatistics: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      options: {
        grid: {
          top: "20%",
          left: "5%",
          right: "5%",
          bottom: "8%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
          formatter: function (x) {
            let shenshui = x[0].data + '次'
            let zhongshui = x[0].axisValue
            let ss = '<div>' + shenshui + '</div>'
            let zs = '<div>' + zhongshui + '</div>'
            let ddv =zs + ss
            return ddv
          },
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              show: false, // 不显示坐标轴刻度线
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#7D7D7D", // x轴的颜色
              },
            },
            axisLabel: {
              textStyle: {
                color: "#393939", // X轴文字颜色
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#eeeeee",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#393939",
              fontSize: 14,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#e7e9ef",
                type: "dashed",
              },
            },
          },
        ],
        series: [
          {
            type: "line",
            smooth: true,
            symbol: "none", // 不显示连接点
            lineStyle: {
              width: 1,
              color: "#4CB5FF" // 线条颜色
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#CFEBFF", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#fff", // 100% 处的颜色
                  },
                ],
                global: false,
              },
            },
            data: [],
          },
        ],
      },
    };
  },
  created() {
    let sss = {...this.options}
    sss.xAxis[0].data = []
    sss.series[0].data = []
    this.heartRateStatistics.forEach(item => {
      // item.sleepDate = item.sleepDate.slice(12, 19)
      let ad = item.bodyNumber
      sss.xAxis[0].data.push(item.sleepDate)
      sss.series[0].data.push(ad)
    })
    this.options = {...sss}
  },
  watch: {
    heartRateStatistics: {
      handler(newData, oldData) {
        if (newData) {
          this.heartRateStatistics = newData
          let sss = {...this.options}
          sss.xAxis[0].data = []
          sss.series[0].data = []
          this.heartRateStatistics.forEach(item => {
            // item.sleepDate = item.sleepDate.slice(12, 19)
            let ad = item.bodyNumber
            sss.xAxis[0].data.push(item.sleepDate)
            sss.series[0].data.push(ad)
          })
          this.options = {...sss}
        } else {
          this.heartRateStatistics = oldData
        }
      }
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.sleepTimes {
  width: 100%;
  height: 100%;
  .eacharts {
    width: 100%;
    height: 250px;
  }
}
</style>